<template>
  <Nav></Nav>
  <main class="block">
    <h1>アカウント</h1>
    <back-button></back-button>
    <TableAccount :accounts="accounts" :newUri="newUri" :newCaption="newCaption" />
  </main>
  <Dialog ref="error" class="dialog">
    <h4 class="title">Error</h4>
    <div class="message">
      <p class="text">{{ error.message }}</p>
    </div>
    <div class="action">
      <button class="btn btn-light" @click="errorClose">Close</button>
    </div>
  </Dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Dialog from '@/components/Dialog.vue';
import TableAccount from '@/components/AccountTable.vue';
import Nav from '@/components/Nav.vue';
import type { AccountData } from '@/lib/account';
import { Account } from '@/lib/account';
import BackButton from '@/components/BackButton.vue';
type TableAccountData = AccountData;
export default defineComponent({
  name: 'Accounts',
  components: {
    BackButton,
    Dialog,
    Nav,
    TableAccount,
  },
  data() {
    return {
      accounts: [] as TableAccountData[],
      newUri: '/accounts/new',
      newCaption: '新しいアカウントの作成',
      error: {
        message: '',
        back: false,
      },
    };
  },
  async mounted() {
    const ac = new Account();
    try {
      const data = await ac.all();
      if (data) {
        this.accounts = data as any;
      }
    } catch (e) {
      if (e instanceof Error) {
        this.error.message = e.message;
        this.error.back = true;
        (this.$refs.error as InstanceType<typeof Dialog>)?.open();
      }
      console.warn(e);
    }
  },
  methods: {
    errorClose() {
      (this.$refs.error as InstanceType<typeof Dialog>)?.close();
      this.error.back && this.$router.back();
    },
  },
});
</script>

<style lang="scss" scoped>
@use '@/assets/dialog.scss' as *;

.dialog {
  @include dialog();
}
</style>
